import { PlausibleEvent } from 'enums/plausible'
import { useEffect, useMemo } from 'react'
import usePlausible from 'utils/hooks/usePlausible'
import { useInfoProviderContext } from 'utils/providers/InfoProvider/InfoProviderContext'

import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { useRouter } from 'next/router'

import AuthLayout from 'layouts/AuthLayout'

import RegisterFormOrGoogle from 'components/RegisterFormOrGoogle/RegisterFormOrGoogle'
import StructuredData from 'components/StructuredData/StructuredData'

const DynamicRestrictedModal = dynamic(() => import('components/RestrictedModal'))

const SignupPage = ({
  referrer,
  ssrHost,
}: {
  referrer: string
  ssrHost: string
}) => {
  const hostName = process.env.NEXT_PUBLIC_BN_HOSTNAME === ssrHost ? 'Binany24' : 'Binany'
  const domainName = useMemo(
    () => (ssrHost ? ssrHost.split('.')[ssrHost.split('.').length - 1] : 'com'),
    [ssrHost],
  )
  const router = useRouter()

  useEffect(() => {
    const exitingFunction = () => {
      localStorage.removeItem('registeringFromPopup')
    }

    router.events.on('routeChangeStart', exitingFunction)

    return () => {
      router.events.off('routeChangeStart', exitingFunction)
    }
  }, [])

  const setEvent = usePlausible()

  useEffect(
    () =>
      // setEvent(PlausibleEvent.OpenRegisterPage, {
      //   type: `user`,
      //   appName: 'mainLanding',
      // });
      setEvent(PlausibleEvent.OpenedSignUp, {
        step: 1,
        source: router.query?.from as string,
        referrer,
      }),
    [],
  )

  const info = useInfoProviderContext()

  if (info?.restricted === true) {
    return <DynamicRestrictedModal />
  }

  return (
    <>
      <StructuredData host={ssrHost} variant="base" path="/auth/signup" />
      <Head>
        <title>
          Binany register | {hostName}.{domainName} sign up
        </title>
        <meta
          name="description"
          content={`Registration to the ${hostName} trading platform. Sign up and get a bonus!`}
        />

        <meta property="og:title" content={`Binany register | ${hostName}.${domainName} sign up`} />
        <meta
          property="og:description"
          content={`Registration to the ${hostName} trading platform. Sign up and get a bonus!`}
        />
        <meta property="og:image" content={`https://${ssrHost}/images/ogImages/authSignup.png`} />
        <meta property="og:site_name" content="Binany - Online Platform for Trading" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://${ssrHost}/auth/signin`} />
      </Head>
      <AuthLayout>
        <RegisterFormOrGoogle referrer={referrer} />
      </AuthLayout>
    </>
  )
}

export default SignupPage

export async function getServerSideProps({ locale, req }) {
  return {
    props: {
      ssrHost: req.headers.host || '',
      ...(await serverSideTranslations(locale, ['main', 'contacts', 'shared', 'error'])),
    },
  }
}
